import { render, staticRenderFns } from "wisaapp-webstudent/src/components/opleiding/opleiding.html?vue&type=template&id=8d68efd2&"
import script from "wisaapp-webstudent/src/components/opleiding/opleiding.js?vue&type=script&lang=js&"
export * from "wisaapp-webstudent/src/components/opleiding/opleiding.js?vue&type=script&lang=js&"
import style0 from "wisaapp-webstudent/src/components/opleiding/opleiding.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports